import {req, ref, withParams, regex} from "vuelidate/lib/validators/common";
import {email, maxLength} from "vuelidate/lib/validators"
import {isNotEmpty, isEmpty} from "@/helpers/validators";
import * as cuilcuit from '@/helpers/cuil-cuit';
import moment from 'moment';

/**
 * Custom validator to know if a given string separated with a delimiter is a valid Email List
 * Closure
 * @param {*} delimiter The character delimiter for the given list
 * @returns {function} Returns a function which receives a string to evaluate if it's a email list
 */
const emailList = (delimiter=',')=>{
  return function(param){
    if(param.trim().length<=0)
      return true;

    if(param.replace(/\s/g,'').split(';').filter(value => value.length == 0).length > 0)
      return false;
  
    return param
      .split(`${delimiter}`)
      .map(value=>value.trim())
      .filter(value=>value.length>0)
      .every(email)
  }
};

const isBooleanValue=(expect=true)=>(param)=>param==expect

const isCUILCUIT = (genre)=>{
  return function(param){
    try{
      genre = genre.trim();
      if(isEmpty(genre))
        return false;
      //length of groups == 3
      if(param.split("-").filter(isNotEmpty).length != 3)
        return false;
      //all groups are numbers
      if(param.split("-").every(Number.isInteger))
        return false;
      //Generate cuit and validate it agains the param
      return cuilcuit.get(param.split("-")[1],genre) === param
    }catch(error){
      return false;
    }
    
  }
}

const isCleanEspecialCharacter = regex('isCleanEspecialCharacter', /^[A-Za-z0-9\s]+$/); 

const minDateFrom = (minDateAttribute) =>withParams({ type: 'minDateFrom', minDateAttribute }
  , function(value, parentVm) {
    if(isEmpty(value) || isEmpty(ref(minDateAttribute, this, parentVm)))
      return true;
    
    const dateValue= moment(value);
    const minDateValue = moment(ref(minDateAttribute, this, parentVm));

    return dateValue.diff(minDateValue,'days')>=0;
  }
)

const valMaxTiempoEspera = (maxTiempoAttribute) =>withParams({ type: 'valMaxTiempoEspera', maxTiempoAttribute }
  , function(value, parentVm){
    
    if(!(isEmpty(value.toString()) || isEmpty(parentVm.tiempoMaximoEsperaRespuesta.toString()))){
      if(parseInt(value) < parseInt(parentVm.tiempoMaximoEsperaRespuesta)){
        return true;
      }
    }
    return false;
  }
)

const maxDateFrom = (maxDateAttribute) =>withParams({ type: 'maxDateFrom', maxDateAttribute }
  , function(value, parentVm) {
    if(isEmpty(value) || isEmpty(ref(maxDateAttribute, this, parentVm)))
      return true;
    
    const dateValue= moment(value);
    const minDateValue = moment(ref(maxDateAttribute, this, parentVm));

    return dateValue.diff(minDateValue,'days')<=0;
  }
)


const alphaNumDot = regex('alpha', /^[a-zA-Z0-9.]+$/);

const urlRegexFtpAmex = /^(?:(?:sftp?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i

const urlFTP = regex('url', urlRegexFtpAmex);

export {
  emailList
  , isBooleanValue
  , isCUILCUIT
  , minDateFrom
  , maxDateFrom
  , alphaNumDot
  , urlFTP
  , valMaxTiempoEspera
  , isCleanEspecialCharacter
}

export default {
  data(){
    return {
      emailList
      , isBooleanValue
      , isCUILCUIT
      , minDateFrom
      , maxDateFrom
      , urlFTP
      , valMaxTiempoEspera
      , isCleanEspecialCharacter
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/vuelidate/validators.js